import { useLayoutEffect, useMemo, useState, useSyncExternalStore } from 'react'
import { useWorkspace } from '../context/WorkspaceContext'
import { getApiWorkspaceVersion, subscribeApiWorkspace } from '../api/workspaceState'
import { createRequestScope } from './requestScope'

/** Independent channels share one mounted view and resolved access context. */
export function useRequestScope(localKey = '') {
  const { currentWorkspaceId, ready, actorTelegramUserId, ownerTelegramUserId, role, permissions } = useWorkspace()
  const version = useSyncExternalStore(subscribeApiWorkspace, getApiWorkspaceVersion, () => 0)
  const key = JSON.stringify([version, currentWorkspaceId, ready, actorTelegramUserId, ownerTelegramUserId, role, permissions, localKey])
  const [scope] = useState(createRequestScope)
  useLayoutEffect(() => {
    scope.activate(key)
    return () => scope.dispose()
  }, [scope, key])
  return useMemo(() => ({ key, begin: (channel: string) => scope.begin(channel, key), cancel: scope.cancel }), [scope, key])
}

/** Global database actions can intentionally change workspace after committing. */
export function useViewRequestScope() {
  const [scope] = useState(() => createRequestScope({ workspaceBound: false }))
  useLayoutEffect(() => { scope.activate(); return () => scope.dispose() }, [scope])
  return scope
}
